export default __webpack_public_path__ + "static/media/sportsbra-small-front-toobig.efc860bc.jpg";